import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import * as fromRoot from '../../state';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

@Injectable()
export class SignUpGuard implements CanActivate {
  constructor(private store$: Store<fromRoot.State>, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.store$.select(fromRoot.getIsAuthenticated).pipe(
      map(isAuthenticated => {
        console.error(isAuthenticated);
        if (isAuthenticated) {
          this.router.navigate(['/']);
        }
        return !isAuthenticated;
      })
    );
  }
}
